// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"143":"e70e736dc4e188df","288":"f5697fe5ee1cf83a"}[chunkId] + ".js";
};